export function setClientCookie(
  name: string,
  value: string,
  maxAgeSeconds = 31536000,
): void {
  if (typeof document === 'undefined') return;
  try {
    const secure =
      typeof window !== 'undefined' && window.location.protocol === 'https:';
    document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; path=/; max-age=${maxAgeSeconds}; SameSite=Lax${secure ? '; Secure' : ''}`;
  } catch {
    /* ignore */
  }
}
